import { resolveAuthorSlug } from './AuthorDiscussionsSource';
import PostListSource from './PostListSource';
import { relatedId } from './realtimeEvents';

/** A member's newest comments anywhere, by id so renames don't break it. */
export default class AuthorPostsSource extends PostListSource {
  constructor(userId) {
    super({
      filter: {}
    });
    this.userId = userId;
  }
  matches(post) {
    const authorId = relatedId(post, 'user');
    return authorId === null ? undefined : authorId === this.userId;
  }
  mayMatchNewDiscussion(discussion) {
    const authorId = relatedId(discussion, 'user');
    return authorId === null ? undefined : authorId === this.userId;
  }
  prepare() {
    return resolveAuthorSlug(this.userId).then(slug => {
      this.state.getParams().filter = {
        author: slug
      };
    });
  }
}
flarum.reg.add('flarum-deck', 'forum/columns/AuthorPostsSource', AuthorPostsSource);